import { FormControl, FormGroup } from '@angular/forms';
import {AngularFirestore} from '@angular/fire/firestore';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RecensioniService {
  constructor(private firestore: AngularFirestore ) {}

  form = new FormGroup({
    nome: new FormControl(''),
    cognome: new FormControl(''),
    description: new FormControl(''),
    punteggio: new FormControl(''),
    link: new FormControl('')
  });


  getRecensioni() {
    return this.firestore.collection('recensioni', ref => {
      return ref.orderBy('punteggio', 'desc');
    }).snapshotChanges();
  }


  getLink() {
    return this.firestore.collection('meeting', ref => {
      return ref.orderBy('link', 'asc');
    }).snapshotChanges();
  }


}
